export default (cookie_name: string, cookie_value: any, cookie_expiration_days: number, cookie_path: string, cookie_domain: null | string) => {
	let date = new Date();
	date.setTime(date.getTime() + (cookie_expiration_days * 24 * 60 * 60 * 1000));
	if (cookie_domain !== null) {
		document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=${cookie_path};Domain=${cookie_domain}`;
	} else {
		document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=${cookie_path};`;
	}
}